import { render, staticRenderFns } from "./ShareStandardUserCheckBoxs.vue?vue&type=template&id=42f0a610&scoped=true&lang=pug"
import script from "./ShareStandardUserCheckBoxs.vue?vue&type=script&lang=ts"
export * from "./ShareStandardUserCheckBoxs.vue?vue&type=script&lang=ts"
import style0 from "./ShareStandardUserCheckBoxs.vue?vue&type=style&index=0&id=42f0a610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f0a610",
  null
  
)

export default component.exports